import { Alert, Button, Typography } from "@mui/material";
import { REPORT_REASONS } from "constants";

export const ReviewStatusAlert = ({ review, ownPendingReport }) => {
  const { status, dealStatus, restaurantStatus, reportedBy } = review;

  const hasPendingReports = reportedBy?.some((r) => r.status === "pendingReport");
  const statusesToAlert = ["pendingCreate", "pendingEdit", "pendingDelete", "reported"];
  const isAlertRequired =
    statusesToAlert.includes(status) ||
    hasPendingReports ||
    dealStatus === "disabled" ||
    restaurantStatus === "disabled";

  if (!isAlertRequired) return null;

  const isDisabled = dealStatus === "disabled" || restaurantStatus === "disabled";
  const messages = {
    pendingCreate: "Your review is pending approval and is only visible to you.",
    pendingEdit: "Your edited review is pending approval and is only visible to you.",
    pendingReport: "You have flagged this review and is currently under administrative review.",
    reported: "Your review has been flagged and is currently hidden from public view.",
  };

  const effectiveStatus = hasPendingReports ? "pendingReport" : status;

  return (
    <Alert
      severity={isDisabled || status === "reported" ? "error" : "warning"}
      sx={{ mt: 1, fontSize: "0.75rem" }}
      action={
        status === "pendingDelete" && (
          <Button color="inherit" size="small" sx={{ textTransform: "none" }}>
            Cancel
          </Button>
        )
      }
    >
      {isDisabled ? (
        <>
          The associated {review.dealId ? "food" : "restaurant"} has been disabled.
          <br />
          You cannot create, edit or delete a review at this time.
        </>
      ) : (
        <>
          {messages[effectiveStatus]}
          {effectiveStatus === "pendingReport" && ownPendingReport?.reason && (
            <>
              <br />
              <Typography variant="caption" component="span">
                <strong>Reason: </strong>
                {REPORT_REASONS.find((r) => r.value === ownPendingReport.reason)?.label ?? ownPendingReport.reason}
              </Typography>
              {ownPendingReport.description && (
                <>
                  <br />
                  <Typography variant="caption" component="span" sx={{ fontStyle: "italic" }}>
                    {ownPendingReport.description}
                  </Typography>
                </>
              )}
            </>
          )}
        </>
      )}
    </Alert>
  );
};